import { errorCodes, getUserFriendlyErrorMessage } from '../../../utils/errormessages'
import { text } from '../Constants'

/**
 * Maps an API error body (the parsed server response) to the user-facing message string,
 * reproducing the exact branching the old ViewServiceListener `*_ERROR` / `ERROR` cases used.
 */
export function getViewServiceErrorMessage(body: unknown): string {
  const errorBody = body && typeof body === 'object' ? body : {}

  const rawCode = 'UserFriendlyErrorCode' in errorBody ? errorBody.UserFriendlyErrorCode : undefined
  const userFriendlyErrorCode = typeof rawCode === 'string' || typeof rawCode === 'number' ? rawCode : undefined
  const rawExtra = 'extra' in errorBody ? errorBody.extra : undefined
  const extra = typeof rawExtra === 'string' ? rawExtra : undefined

  if (userFriendlyErrorCode || userFriendlyErrorCode === '') {
    return userFriendlyErrorCode ? getUserFriendlyErrorMessage(userFriendlyErrorCode, null, extra) : ''
  }

  const errorCode = 'ErrorCode' in errorBody ? errorBody.ErrorCode : undefined

  switch (errorCode) {
    case 'ServiceTypeNotFound':
      return getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, 'Service type')
    case 'NameNotValid':
      return getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Service Type')
    case 'DescriptionNotValid':
      return getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Service description')
    case 'VisitTypeIntakeFormCountNotValid':
      return getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Intake forms')
    case 'NameNotUnique':
      return getUserFriendlyErrorMessage(errorCodes.NAME_ALREADY_EXISTS, null, 'Service type')
    case 'VisitTypeCostNotValid':
    case 'VisitTypeNameNotValid':
    case 'VisitTypeCancellationFeeNotValid':
      return getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS)
    case 'InternalServerError':
      return getUserFriendlyErrorMessage(errorCodes.DEFAULT)
    case 'IntakeFormNotFound':
      return getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, text.INTAKE_FORM)
    default:
      return getUserFriendlyErrorMessage(errorCodes.DEFAULT)
  }
}
